import { inject } from '@angular/core';
import { RedirectFunction } from '@angular/router';
import { ERole } from 'src/app/shared/roles/models/role.enum';
import { RoleService } from '../services/role.service';

/**
 * Based on a user's roles, picks a new route as their default.
 * 
 * @export
 */
export const redirectFn: RedirectFunction = () => {
  const roleService = inject(RoleService);

  if (roleService.hasAnyRole([ERole.ASSIGNED_QUEUE, ERole.TEAM_REVIEW_QUEUE])) {
    // Queues -- if user has ASSIGNED_QUEUE or TEAM_REVIEW_QUEUE role
    return 'incident-queue/active';
  } else if (roleService.hasRole(ERole.IR_SUBMIT)) {
    // New Liberty Way -- if user has IR_SUBMIT role
    return 'new/liberty-way-ir';
  } else if (roleService.hasRole(ERole.GROUP_DOS_INFORMATIONAL)) {
    // New Informational -- if user has GROUP_DOS_INFORMATIONAL role
    return 'new/informational-ir';
  } else if (roleService.hasRole(ERole.OGSA_FACULTY)) {
    // New Honor Code -- if user has OGSA_FACULTY role
    return 'new/honor-code';
  } else if (roleService.hasAnyRole([ERole.LUOA_FACULTY, ERole.DUAL_ENROLLMENT_FACULTY])) {
    // New LUOA Honor Code -- if user has LUOA_FACULTY role
    return 'new/luoa-honor-code';
  } else {
    // Student Status -- (everyone else)
    return 'student/cases';
  }
};
